import { getUtmFirst, getUtmLast } from "@/helpers/utmTracking";

function postFF(url, bodyObj) {
  try {
    const json = JSON.stringify(bodyObj);

    // Browser: best-effort background send
    if (
      typeof navigator !== "undefined" &&
      typeof navigator.sendBeacon === "function"
    ) {
      const blob = new Blob([json], { type: "application/json" });
      navigator.sendBeacon(url, blob);
      return; // no await
    }

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: json,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // swallow everything — truly fire-and-forget
  }
}

export function trackPreReg(apiBase, sessionId, step) {
  if (!apiBase || !sessionId || !step) return;
  const body = { sessionId: String(sessionId), step: String(step) };
  try {
    const sf =
      typeof sessionStorage !== "undefined" &&
      sessionStorage.getItem("ael_pre_reg_source");
    if (sf) body.sourceFlow = sf;
    // UTM: send once per session (first event that succeeds)
    const utmSent =
      typeof sessionStorage !== "undefined" &&
      sessionStorage.getItem("ael_pre_reg_utm_sent");
    if (!utmSent) {
      const utmFirst = getUtmFirst();
      const utmLast = getUtmLast();
      if (utmFirst || utmLast) {
        body.utm = {};
        if (utmFirst) body.utm.first = utmFirst;
        if (utmLast) body.utm.last = utmLast;
        sessionStorage.setItem("ael_pre_reg_utm_sent", "1");
      }
    }
  } catch {}
  postFF(`${apiBase}/track/pre-reg`, body);
}

export function trackPreRegLink(apiBase, sessionId, vehicleId) {
  if (!apiBase || !sessionId || !vehicleId) return;
  postFF(`${apiBase}/track/pre-reg/link`, {
    sessionId: String(sessionId),
    vehicleId: String(vehicleId),
  });
}
